<template>
    <basic-container id="engineering20211209">
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   :search.sync="searchForm"
                   ref="crud"
                   id='guiruhao20211209'
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">

          <template slot="projectIdSearch" slot-scope="scope">
            <el-select
              v-model="searchForm.projectId"
              placeholder="请选择医院名称"
              style="width: 80%"
              @change="(value)=>projectChange(value)"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>

          <template slot="projectIdForm" slot-scope="scope">
            <el-select
              :disabled='editMode'
              v-model="form.projectId"
              placeholder="请选择医院名称"
              style="width: 60%"
              @change="(value)=>projectChange_(value)"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
<!--          <template>
            <div class="block">
              <el-date-picker
                v-model="value2"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </template>-->

<!--            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.engineering_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>-->
             <template slot-scope="scope" slot="menu">
              <el-button icon="el-icon-check" size="small" @click="showEditThresholdModel(scope.row)" style="color: #409EFF;border:0;font-size:12px;line-height: 1;white-space: nowrap;cursor: pointer;">编制计划</el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/engineering/engineering";
    import {mapGetters} from "vuex";
    import {getProjectList} from "@/api/crmedical/project/project";
    import {getProjectDict} from '@/api/crmedical/project-dictionary/project-dictionary';
    import EngineeringPlan from "./engineeringplan";

    export default {
      components: {
        EngineeringPlan
      },
        data() {
            return {
              value2:'',
              firstDisplayFlag:false,
              editMode:false,
              form: {},
              query: {
                projectId:'',
              },
              // loading: true,
              page: {
                  pageSize: 10,
                  currentPage: 1,
                  total: 0
              },
              projectList:[],
              selectionList: [],
              option: {
                indexLabel:"序号",
                height: 'auto',
                calcHeight: 20,
                labelWidth: 130,
                tip: false,
                searchShow: true,
                searchMenuSpan: 6,
                span: 8,
                border: true,
                index: true,
                viewBtn: true,
                selection: true,
                dialogClickModal: false,
                column: [
                  {
                    title: '分割线',
                    component: 'el-divider',
                    span: 24,
                    hide:true,
                    tips: '',
                    labelWidth: '100px',
                    params: {
                      contentPosition: 'left'
                    },
                    prop: 'title1',
                    change: ({value}) => {

                    },
                    labelTip: '',
                    label: '立项信息',
                    detail: false
                  },
                            {
                              label: "医院名称",
                              prop: "projectName",
                              search: false,
                              viewDisplay:false,
                              addDisplay:false,
                              editDisplay:false,
                            },
                            {
                              label: "医院名称",
                              prop: "projectId",
                              // cascaderItem: ['progressStage','startupWay'],
                              hide:true,
                              span:8,
                              search:true,
                              searchslot:true,
                              searchSpan:5,
                              formslot:true,
                              rules: [{
                                required: true,
                                message: "请选择医院",
                                trigger: "blur"
                              }]
                            },
                            /*{
                              label: "医院名称",
                              prop: "projectId",
                              type: 'select',
                              searchClearable:false,
                              search: true,
                              searchSpan:5,
                              cascaderItem: ['progressStage','startupWay'],
                              dicUrl: 'api/v4ward/project/getProjectList',
                              props: { label: 'name', value: 'id' },
                              rules: [{
                                required: true,
                                message: "请选择医院名称",
                                trigger: "change"
                              }]
                            },*/
                            {
                              label: "项目编号",
                              prop: "code",
                              search:true,
                              maxlength: 30,
                              showWordLimit: true,
                              rules: [{
                                  required: true,
                                  message: "请输入项目编号",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "项目名称",
                              prop: "name",
                              search:true,
                              maxlength: 30,
                              showWordLimit: true,
                              rules: [{
                                  required: true,
                                  message: "请输入项目名称",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "项目年度",
                              prop: "annual",
                              search:true,
                              type: "year",
                              rules: [{
                                  required: true,
                                  message: "请选择项目年度",
                                  trigger: "change"
                              }]
                            },
                  {
                    label: "项目节点",
                    prop: "progressStageName",
                    search: false,
                    viewDisplay:false,
                    addDisplay:false,
                    editDisplay:false,
                  },
                            {
                              label: "项目节点",
                              prop: "progressStage",
                              type: "select",
                              search:true,
                              hide:true,
                              dataType: 'number',
                              searchPlaceholder:"请选择 项目节点",
                              dicUrl: "/api/v4ward/projectDict/dictionary?code=engineering_progress_stage&projectId={{key}}",
                              props: {
                                label: "dictValue",
                                value: "dictKey",
                              },
                              rules: [{
                                  required: false,
                                  message: "请选择项目节点",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "项目负责人id",
                              prop: "chargeUserId",
                              hide:true,
                              viewDisplay:false,
                              addDisplay:false,
                              editDisplay:false,
                              rules: [{
                                required: false,
                                message: "请输入项目负责人",
                                trigger: "change"
                              }]
                            },
                            {
                                label: "项目负责人",
                                prop: "chargeUserName",
                              search:true,
                                rules: [{
                                    required: true,
                                    message: "请输入项目负责人",
                                    trigger: "change"
                                }]
                            },
                  {
                    label: "立项方式",
                    prop: "startupWayName",
                    search: false,
                    viewDisplay:false,
                    addDisplay:false,
                    editDisplay:false,
                  },
                            {
                              label: "立项方式",
                              prop: "startupWay",
                              type: "select",
                              search:true,
                              hide:true,
                              dataType: 'number',
                              searchPlaceholder:"请选择 整改对象",
                              props: {
                                label: "dictValue",
                                value: "dictKey",
                              },
                              dicUrl: "/api/v4ward/projectDict/dictionary?code=engineering_startup_way&projectId={{key}}",
                              rules: [{
                                  required: false,
                                  message: "请选择立项方式",
                                  trigger: "change"
                              }]
                            },
                  /*{
                    type: 'daterange',
                    label: '立项日期',
                    span: 8,
                    search:true,
                    display: true,
                    format: 'yyyy-MM-dd',
                    valueFormat: 'yyyy-MM-dd',
                    prop: 'startDate',
                    change: ({value}) => {

                    }
                  },*/
                            {
                              label: "立项日期",
                              prop: "startupDate",
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: true,
                                  message: "请输入立项日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "预算金额（万）",
                              prop: "budgetAmount",
                              maxlength: 14,
                              rules: [{
                                  required: true,
                                  message: "请输入预算金额",
                                  trigger: "change"
                              },
                                {pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/, message: '请输入最多4位小数的金额'}
                              ]
                            },
                  {
                    label: "项目进度",
                    colorFormat:'red',
                    prop: "executeStatus",
                    search:true,
                    viewDisplay:false,
                    addDisplay:false,
                    editDisplay:false,
                    type: 'input',
                    dataType: 'number',
                    props: {
                      label: 'dictValue',
                      value: 'dictKey',
                    },
                    dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=engineering_execute_status',
                    rules: [{
                      required: true,
                      message: "请选择",
                      trigger: "change"
                    }]
                  },
                  {
                    title: '分割线',
                    component: 'el-divider',
                    span: 24,
                    hide:true,
                    tips: '',
                    labelWidth: '100px',
                    params: {
                      contentPosition: 'left'
                    },
                    prop: 'title2',
                    change: ({value}) => {

                    },
                    labelTip: '',
                    label: '招议标信息',
                    detail: false
                  },
                            {
                              label: "招标文件上传",
                              prop: "fileUploadDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd',
                              rules: [{
                                  required: false,
                                  message: "请输入招标文件上传",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "招标审批完成",
                              prop: "bidApproveFinishDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入招标审批完成",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "开标/议标日期",
                              prop: "bidOpenDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入开标、议标日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "商务谈判日期",
                              prop: "businessNegotiationDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入商务谈判日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "中标通知日期",
                              prop: "bidWinningNoticeDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入中标通知日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "中标单位id",
                              prop: "partnerId",
                              hide:true,
                              viewDisplay:false,
                              addDisplay:false,
                              editDisplay:false,
                              rules: [{
                                required: false,
                                message: "请输入中标单位",
                                trigger: "change"
                              }]
                            },
                            {
                              label: "中标单位",
                              prop: "partnerName",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入中标单位",
                                  trigger: "change"
                              }]
                            },
                  {
                    title: '分割线',
                    component: 'el-divider',
                    span: 24,
                    hide:true,
                    tips: '',
                    labelWidth: '100px',
                    params: {
                      contentPosition: 'left'
                    },
                    prop: 'title3',
                    change: ({value}) => {

                    },
                    labelTip: '',
                    label: '合同信息',
                    detail: false
                  },
                            {
                              label: "合同会签日期",
                              prop: "contractCountersignDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入合同会签日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "合同金额（万）",
                              prop: "contractAmount",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入合同金额",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "合同签订日期",
                              prop: "contractSignDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入合同签订日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "合同工期（天）",
                              prop: "contractLimitDay",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入合同工期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "施工方联系人",
                              prop: "workChargeName",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入施工方联系人",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "施工方电话",
                              prop: "workChargeTel",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入施工方电话",
                                  trigger: "change"
                              }]
                            },
                  {
                    title: '分割线',
                    component: 'el-divider',
                    span: 24,
                    hide:true,
                    tips: '',
                    labelWidth: '100px',
                    params: {
                      contentPosition: 'left'
                    },
                    prop: 'title4',
                    change: ({value}) => {

                    },
                    labelTip: '',
                    label: '施工结算信息',
                    detail: false
                  },
                            {
                              label: "开工日期",
                              prop: "workStartDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入开工日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "竣工日期",
                              prop: "workFinishDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入竣工日期",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "结算资料送审",
                              prop: "settlementDataSubmitDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入结算资料送审",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "审计报告",
                              prop: "auditReportDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入审计报告",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "审定金额（万）",
                              prop: "auditAmount",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入审定金额",
                                  trigger: "change"
                              },
                                {pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/, message: '请输入最多4位小数的金额'}
                              ]
                            },
                            {
                              label: "预付款（万）",
                              prop: "prepayAmount",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入预付款",
                                  trigger: "change"
                              },{pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/, message: '请输入最多4位小数的金额'}
                              ]
                            },
                            {
                              label: "进度款（万）",
                              prop: "progressAmount",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入进度款",
                                  trigger: "change"
                              },{pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/, message: '请输入最多4位小数的金额'}
                              ]
                            },
                            {
                              label: "质保金额（万）",
                              prop: "qualityGuaranteeAmount",
                              hide:true,
                              rules: [{
                                  required: false,
                                  message: "请输入质保金额",
                                  trigger: "change"
                              },{pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/, message: '请输入最多4位小数的金额'}
                              ]
                            },
                            {
                              label: "质保金支付",
                              prop: "qualityGuaranteePayDate",
                              hide:true,
                              type: 'date',
                              format: 'yyyy-MM-dd',
                              valueFormat: 'yyyy-MM-dd HH:mm:ss',
                              rules: [{
                                  required: false,
                                  message: "请输入质保金支付",
                                  trigger: "change"
                              }]
                            },
                            {
                              label: "备注",
                              prop: "remark",
                              hide:true,
                              type:'textarea',
                              span: 24,
                            },
                          ]
                },
                data: [],
                firstProjectId: false,
              disabled: false,
              searchForm:{

              },
            };
        },
      watch: {
        'query.projectId'(){
          this.oldProjectId = this.query.projectId
        },
      },
      mounted(){
        // this.option.height = this.bodyHeight-398
        // console.log(this.option);
        window.onresize = ()=>{
          this.$refs.crud.$refs.table.doLayout()
        }
      },
      created(){
        getProjectList().then((res)=>{
          this.projectList = res.data;
          this.query.projectId = res.data[0].id;
          this.searchForm.projectId = res.data[0].id;
          this.firstProjectId = true;
          this.onLoad();
          this.firstDisplayFlag = true;
        })
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.engineering_add, false),
                    viewBtn: this.vaildData(this.permission.engineering_view, false),
                    delBtn: this.vaildData(this.permission.engineering_delete, false),
                    editBtn: this.vaildData(this.permission.engineering_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
          showEditThresholdModel(){
            console.log('滴滴滴滴滴');
          },
          async initData(){
            let progressStage = this.findObject(this.option.column,'progressStage');
            let startupWay = this.findObject(this.option.column,'startupWay');
            await getProjectDict({code:'engineering_progress_stage',projectId:this.searchForm.projectId}).then((res) => {
              console.log('getProjectDict======================>',res.data);
              progressStage.dictData = res.data;
            })
            await getProjectDict({code:'engineering_startup_way',projectId:this.searchForm.projectId}).then((res) => {
              startupWay.dictData = res.data;
              console.log('getProjectDict======================>',res.data);

            })
          },
          projectChange(value){
            console.log('value============================>',value);
            this.initData();
            this.query.projectId = value;
          },
          projectChange_(value){
            this.initData();
            this.form.projectId = value;
          },
          getProjectNameById(projectId) {
            let projectName = '';
            this.projectList.forEach(function (value, index, array) {
              if (value.id === projectId) {
                projectName = value.name;
                return;
              }
            });
            return projectName;
          },
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                  this.editMode = true;
                  this.disabled = true;
                  getDetail({id:this.form.id}).then(({data}) => {
                      this.form = data;
                  });
                }
              if (["add"].includes(type)) {
                this.disabled = false;
                this.editMode = false;
                this.deptNameFlag = true;
                this.form.projectId = this.query.projectId;
                this.form.id = '';
              }
                done();
            },
            searchReset() {
              setTimeout(()=>{
                this.query.projectId = this.oldProjectId;

                this.onLoad();
              },0)
            },
            searchChange(params, done) {
              console.log("param>>>>>",params);
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
              if (!this.firstProjectId) {
                return ;
              }else{
                this.query.projectId?this.query.projectId : this.projectList[0].id;
              }
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                  if (this.firstDisplayFlag) {
                    this.oldProjectId = this.query.projectId
                    //关闭默认显示，重刷页面时才开启默认显示
                    this.firstDisplayFlag = false;
                  }
                });
            }
        }
    };
</script>

<style lang="scss">
#engineering20211209 {
  .avue-crud .el-icon-view {
    display: none;
  }
  .avue-crud .el-icon-edit {
    display: none;
  }
  .avue-crud .el-icon-delete {
    display: none;
  }
  .avue-form__menu--center {
    text-align: right;
  }
}
</style>
